import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import {
  WorkflowManagerConfig,
  WorkflowManagerConfigService,
} from '@features/client/workflow-manager/workflow-manager.config';
import { WorkflowManagerService } from '@features/client/workflow-manager/services/workflow-manager.service';
import { WorkflowApiService } from '@features/client/workflow-manager/services/workflow-api.service';

export function provideWorkflowManager(config: WorkflowManagerConfig): EnvironmentProviders {
  return makeEnvironmentProviders([
    WorkflowApiService,
    {
      provide: WorkflowManagerConfigService,
      useValue: {
        key: config.key,
      },
    },
    {
      provide: WorkflowManagerService,
      useClass: config.workflowManagerService || WorkflowManagerService,
    },
  ]);
}
